module.exports = __webpack_public_path__ + "static/media/skybox_internal_view_m.86efa58c.jpg";